import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  emptyCellOneLevel,
  formatDateWithTime,
  hasPermission,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";

import { useFetchObservacion, useUpdateObservacion, useDeleteObservacion } from "@/shared/actions/erp";
import { Observacion } from "@/shared/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";


export interface ObservacionPageInterface {}
const ObservacionPage: React.FC<ObservacionPageInterface> = () => {
  const returnObservacionUrl = ROUTER_PATHS.administration.observacionNav;
   
  //useCheckPermissions(PermissionsEnum.api_view_iva);

  const navigate = useNavigate();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* fetch data
  const {
    data: ivasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchObservacion({
    page: pageIndex + 1,
    page_size: pageSize,
    nombre: searchTerm,
    ...filterObject,
    filterByState: false,
  });

  //mutaciones
  const updateObservacionMutation = useUpdateObservacion(navigate, returnObservacionUrl);
  const deleteObservacionMutation = useDeleteObservacion();
  ///

  const onEdit = (original:Observacion) =>{
    setConfirmDialog({
      isOpen: true,
      title: "Editar observacion",
      subtitle: "¿Esta seguro que desea editar este registro?",
      onConfirm:() =>{
        setConfirmDialogIsOpen(false);
        navigate(`${returnObservacionUrl}/editar/${original.id_observacion}`)
      }
    });
  
   
  }

  const onDelete = (origin:Observacion) =>{
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar observación",
      subtitle: `¿Está seguro que desea eliminar la observación "${origin.nombre_observacion}"? Esta acción no se puede deshacer.`,
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteObservacionMutation.mutate(origin.id_observacion!);
      },
    });
  };
  


  ///* columns
  const columns = useMemo<MRT_ColumnDef<Observacion>[]>(
    () => [
      {
        accessorKey: "tipo_responsable",
        header: "Responsable",
        size: 180,
        Cell: ({ row }) => row.original?.responsable_data?.tipo_responsable || 'N/A',
      },
      {
        accessorKey: "nombre_observacion",
        header: "Nombre de la observación",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "nombre_observacion"),
      },
      {
        accessorKey: "descripcion",
        header: "descripcion",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "descripcion"),
      },
      {
        accessorKey: "estado",
        header: "Estado de la observación",
        size: 180,
        enableColumnFilter: false,
        enableSorting: false, 
        Cell: ({ row }) => (
          <SwitchComponente
              estadoSwitch = {row.original.estado}
              titulo={row.original.estado ? "Activo":"Inactivo"}
              setEstadoSwitch={(observacion)=>{
                setConfirmDialog({
                  isOpen:true,
                  title: "Cambiar estado",
                  subtitle:"¿Estas seguro que desea cambiar el estado de este registro?",
                  onConfirm: () =>{
                    setConfirmDialogIsOpen(false);
                    updateObservacionMutation.mutate({
                      id:row.original.id_observacion!,
                      data: {
                        ...row.original,
                        estado: observacion as boolean,
                      }
                    })
                  }
                })
              }
            }
          
          />
        ),
      },
      {
        accessorKey: "fecha_creacion",
        header: "Fecha de Creación",
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) =>
          row.original?.fecha_creacion
            ? formatDateWithTime(row.original.fecha_creacion)
            : "N/A",
      },
      {
        accessorKey: "fecha_modificacion",
        header: "Fecha de Modificación",
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) =>
          row.original?.fecha_modificacion
            ? formatDateWithTime(row.original.fecha_modificacion)
            : "N/A",
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene
      title="Observación"
      urlRedirect={`${returnObservacionUrl}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_iva)}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="Observacion Tipo"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<Observacion>
        columns={columns}
        data={ivasPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        //enableSorting={false}
        // // filters - llega al back
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={ivasPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={hasPermission(PermissionsEnum.api_change_observacion)}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"


        // crud
        canEdit={hasPermission(PermissionsEnum.api_change_observacion)}
        onEdit={onEdit}
        //delete

        canDelete={hasPermission(PermissionsEnum.api_delete_observacion)}
        onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
};

export default ObservacionPage;